import { createFileRoute } from '@tanstack/react-router'
import { listProviderTeamUserQuery } from '@/features/provider-panel/team/api/providerTeamManagementApi';
import { TEAM_USERS_PER_PAGE } from '@/features/provider-panel/team/constants';
import { crownQueryClient } from '@/common/api/crownQueryClient';
import { ProviderTeamManagement } from '@/features/provider-panel/team/ProviderTeamManagement.tsx';

export const Route = createFileRoute('/provider/$providerId/team/')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      search: (search.search as string) || undefined,
    };
  },
  loader: ({ params }) => crownQueryClient.ensureInfiniteQueryData(
    listProviderTeamUserQuery({ providerId: params.providerId, perPage: TEAM_USERS_PER_PAGE }),
  ),
  component: ProviderTeamManagement,
})
